import React, { useState } from 'react';

const MessageInput = ({ onSendMessage }) => {
    const [message, setMessage] = useState('');

    const handleSend = () => {
        if (message.trim()) {
            onSendMessage(message);
            setMessage('');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSend();
        }
    };

    return (
        <div className="message-input-area">
            <input 
                type="text" 
                placeholder="Введите сообщение..." 
                className="message-input"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
            />
            <button className="btn-primary" onClick={handleSend}>
                <i className="fas fa-paper-plane"></i> Отправить
            </button>
        </div>
    );
};

export default MessageInput;
